<template>
    <form-autosuggest
        :options="autosuggest_options"
        :loading="searching"
        v-bind="autosuggest_props"
        @search="search"
        @pick="pick"
        @unpick="unpick"
    >
        <template slot="label"><slot name="label"></slot></template>
        <template v-slot:option="{ option }"><slot name="option" :option="option"></slot></template>
    </form-autosuggest>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex"

import FormAutosuggest from "./FormAutosuggest"

export default {
    components: {
        FormAutosuggest
    },
    mounted () {
        this.bootstrap()
    },
    watch: {
        selection: "bootstrap"
    },
    methods: {
        bootstrap () {
            if(this.selection) this.search(this.selection)
        },
        search (query) {
            if(!query || (query.length < 3)) {
                this.option_ids = []
            } else {
                this.searching = true
                this.$store.dispatch("AUTOSUGGEST", { entity: this.entity, context: this.name, query: { ...this.contextData, query } }).then(options => {
                    this.option_ids = this.passthru ? options : options.filter(option => { return !!option[this.idField] && !!option[this.labelField] }).map(option => option[this.idField])
                }).catch(error => {
                    this.$error(error.message)
                }).then(() => {
                    this.searching = false
                })
            }
        },
        pick (option) {
            if(this.editable && this.canAdd && !option.id) {
                const data = {
                    ...this.contextData,
                    ...option
                }
                const payload = { entity: this.entity, context: this.name, data }
                if(this.addHandler) this.addHandler(payload)
                else {
                    this.$store.dispatch("AUTOSUGGEST_ADD", payload).then(option => {
                        this.$emit("pick", option)
                    }).catch(error => {
                        this.$error(error.message)
                    })
                }
            } else this.$emit("pick", option)
        },
        unpick (option) {
            this.$emit("unpick", option)
        }
    },
    computed: {
        ...mapGetters(["entity_records"]),
        autosuggest_props () {
            const { entity, options, contextData, addHandler, ...autosuggest_props } = this.$props
            return autosuggest_props
        },
        autosuggest_options () {
            if(this.passthru) return this.option_ids
            return this.entity_records(this.entity).filter(option => (option.id === this.selection) || (this.option_ids.indexOf(option.id) >= 0))
        }
    },
    props: {
        id: {
            type: String,
            validator: prop => !!prop
        },
        entity: {
            type: String,
            required: true
        },
        name: {
            type: String,
            validator: prop => !!prop,
            required: true
        },
        contextData: {
            type: Object,
            default () {
                return {}
            }
        },
        selection: {
            default: null
        },
        externalSearch: {
            type: String,
            default: ""
        },
        emptyValue: {
            default: 0
        },
        emptyLabel: {
            type: String,
            default: ""
        },
        idField: {
            type: String,
            default: "id"
        },
        labelField: {
            type: String,
            default: "name"
        },
        width: {
            type: String,
            default: "1-1"
        },
        size: {
            type: String,
            validator: prop => !!prop && !!prop.match(/^(small|normal|large)$/i),
            default: "normal"
        },
        placeholder: {
            type: String,
            default: ""
        },
        required: {
            type: Boolean,
            required: true
        },
        editable: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        canAdd: {
            type: Boolean,
            default: false
        },
        addHandler: {
            type: Function
        },
        displayOnFocus: {
            type: Boolean,
            default: true
        },
        displayOnEmpty: {
            type: Boolean,
            default: false
        },
        saving: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            default: ""
        },
        passthru: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            searching: false,
            option_ids: []
        }
    }
}
</script>
